module.exports = __webpack_public_path__ + "img/2.b50512f8.jpg";